import React from "react";
import styles from "./MenuControl.module.scss";
export const MenuControl = ({ isOpen, onChange }) => (<>
    {!isOpen ? (<button onClick={() => onChange(true)} className={styles.buttonOpen} aria-label="open-menu-button">
        <span />
        <span />
        <span />
      </button>) : (<button onClick={() => onChange(false)} className={styles.buttonClose} aria-label="close-menu-button">
        <span />
        <span />
      </button>)}
  </>);
